import shift from "./shift";

const slices = {
  shift,
};

export default slices;
